import React, { FC, useState, FormEvent, useMemo, useEffect } from 'react'
import { Alert } from 'components/Alert'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Card } from 'components/Card'
import { Button } from 'components/Button'
import { useTranslation } from 'react-i18next'
import { SelectInput } from 'components/SelectInput/SelectInput'
import { SelectOptionAdapter } from 'utils/selectOption'
import { Language } from 'models/language'

type LanguageFormProps = {
  language: Language
  languages: Language[]
  submit: (language: string) => Promise<void>
}

// ... (manten tus imports igual)

export const LanguageForm: FC<LanguageFormProps> = (props) => {
  const { t } = useTranslation()
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const adapter = useMemo(() => SelectOptionAdapter('code', 'label'), [])
  const options = useMemo(() => adapter.buildOptions(props.languages), [props.languages, adapter])

  const [selectedCode, setSelectedCode] = useState<string>(props.language.code)

  useEffect(() => {
    setSelectedCode(props.language.code)
  }, [props.language.code])

  // CORRECCIÓN AQUÍ: Cambiamos 'null' por 'undefined' para que TS esté feliz
  const currentSelection = useMemo(() => 
    options.find(opt => opt.value === selectedCode) || undefined, 
  [options, selectedCode])

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    setLoading(true)
    setError(false)
    setSuccess(false)

    props
      .submit(selectedCode)
      .then(() => setSuccess(true))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }

  return (
    <div>
      <Card>
        <Stack>
          <Stack space="small">
            <Heading size="card">{t('account.language.title')}</Heading>
            <Text>{t('account.language.subtitle')}</Text>
          </Stack>

          <form onSubmit={handleSubmit} autoComplete="off">
            <Stack space="medium">
              <SelectInput
                label={t('account.language.form.language')}
                value={currentSelection} // Ahora el tipo coincide perfectamente
                options={options}
                onChange={(option) => {
                  // Agregamos una validación para evitar que el evento de reset de Chrome 
                  // sobreescriba tu selección (el error del log doble)
                  if (option && option.value.toString() !== selectedCode) {
                    console.log("CAMBIO CONFIRMADO A:", option.value);
                    setSelectedCode(option.value.toString());
                  }
                }}
              />

              <Button type="submit" loading={loading} disabled={loading}>
                {t('account.language.form.cta')}
              </Button>
              {success && <Alert tone="positive" full>{t('common.messages.success')}</Alert>}
              {error && <Alert tone="critical" full>{t('common.messages.error')}</Alert>}
            </Stack>
          </form>
        </Stack>
      </Card>
    </div>
  )
}

LanguageForm.displayName = 'LanguageForm'